import React from 'react'
import '../styles/home.css'

function ReviewCard({ description, customerName, onClick }) {
    return (
        <div className="carousel-card"
            onClick={onClick}
        >
            <div className="card-inner">

                <div>
                    <div className="stars">
                        <img src="images/star2.png" height="25px" alt='rating star' />
                        <img src="images/star2.png" height="25px" alt='rating star' />
                        <img src="images/star2.png" height="25px" alt='rating star' />
                        <img src="images/star2.png" height="25px" alt='rating star' />
                        <img src="images/star2.png" height="25px" alt='rating star' />
                    </div>

                    <div className='description-container'>
                        <p className="review-text">{description}</p>
                    </div>
                </div>




                <p className="review-name"><span className="dash">-</span>{customerName}</p>

            </div>
        </div>
    )
}

export default ReviewCard